import React from "react";
import Slider from "react-slick";
import { FaArrowLeft, FaArrowRight } from "react-icons/fa";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { Link } from "react-router-dom";

const cleints = [
  {
    title:
      "Masarrat Misbah Beauty is a premium cosmetic brand offering high-quality, halal-certified makeup products. ",
    src: "/assets/diners.png",
    alt: "Diners",
    url: "https://diners.com.pk/",
  },
  {
    title:
      "Masarrat Misbah Beauty is a premium cosmetic brand offering high-quality, halal-certified makeup products.",
    src: "/assets/masarat.png",
    alt: "Masarrat Misbah",
    url: "https://masarratmakeup.com/",
  },
  {
    title:
      " Laziza International is a renowned food brand offering a variety of high-quality, ready-to-cook spice mixes, desserts, pickles, and culinary essentials.",
    src: "/assets/laziza.png",
    alt: "Laziza International",
    url: "",
  },
  {
    title:
      "MTJ (Maulana Tariq Jameel) is a lifestyle and clothing brand offering modest, high-quality apparel for men, women, and children.",
    src: "/assets/MTJ-clients.png",
    alt: "MTJ",
    url: "https://mtjonline.com/",
  },
  {
    title:
      "If you are looking for online ABC deals with home delivery across Karachi then look no further, order now your favorite ABC from Candy Land & enjoy your day.",
    src: "/assets/candyland.png",
    alt: "Candyland",
    url: "https://candyland.com.pk/",
  },
  {
    title:
      "WhiteDuck Outdoors is a premium outdoor gear brand specializing in high-quality, durable canvas tents, tarps, and camping accessories.",
    src: "/assets/whiteduck-logo.png",
    alt: "Whiteduck",
    url: "https://whiteduckoutdoors.com/",
  },
  {
    title:
      "Money Back Guarantee (MBG) is a 2023 Pakistani political satire heist comedy directed by Faisal Qureshi.",
    src: "/assets/mbg.png",
    alt: "MBG",
    url: "",
  },
];

const CustomPrevArrow = ({ onClick }) => (
  <button
    className="absolute left-0 z-10 text-2xl text-black top-10 hover:text-gray-700"
    onClick={onClick}
  >
    <FaArrowLeft />
  </button>
);

const CustomNextArrow = ({ onClick }) => (
  <button
    className="absolute right-0 text-2xl text-black top-10 hover:text-gray-700"
    onClick={onClick}
  >
    <FaArrowRight />
  </button>
);

const maxDots = 5;

const Section6 = () => {
  const settings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 5,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 3000,
    arrows: true,
    appendDots: (dots) => (
      <div>
        <ul className="flex justify-center">
          {dots.slice(0, maxDots)} {/* Show only first 5 dots */}
        </ul>
      </div>
    ),
    prevArrow: <CustomPrevArrow />,
    nextArrow: <CustomNextArrow />,
    responsive: [
      { breakpoint: 1024, settings: { slidesToShow: 4 } },
      { breakpoint: 768, settings: { slidesToShow: 3 } },
      { breakpoint: 480, settings: { slidesToShow: 1 } },
    ],
  };

  return (
    <div className="container-1280 -py-10 md:py-[10px] xl:min-w-[70%] lg:min-w-[90%] w-[95%] m-auto ">
      <div>
        <h2 className="mb-8 text-[26px] md:text-[30px] font-bold text-[#ea2339] leading-[28px] md:leading-[34px]">
          A Small Selection Of Our Clients
        </h2>
      </div>
      <div className="relative w-full py-6 mx-auto">
        <Slider {...settings}>
          {cleints.map((brand, index) => (
            <div key={index} className="px-2">
              <Link to={brand.url}>
                <img
                  src={brand.src}
                  alt={brand.alt}
                  className="object-cover h-20 mx-auto rounded-md w-30"
                />
              </Link>
            </div>
          ))}
        </Slider>
        {/* <p className="mt-4 text-center text-gray-600">{brand.title}</p> */}
      </div>
      <div className="w-full h-px mt-10 bg-gray-800"></div>
    </div>
  );
};

export default Section6;
